import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routing } from './app.routes';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker'; 
import { MatIconModule } from '@angular/material/icon'; 
import { MatButtonModule } from '@angular/material/button'; 
import { MatRadioModule } from '@angular/material/radio'; 
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {NgxPrintModule} from 'ngx-print';

import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HomeComponent } from './dashboard/home/home.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import 'hammerjs';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FigurecardComponent } from './shared/figurecard/figurecard.component';
import { ImagecardComponent } from './shared/imagecard/imagecard.component';
import { TableComponent } from './dashboard/table/table.component';
import { NotificationComponent } from './dashboard/notification/notification.component';
import { MsgIconBtnComponent } from './shared/msgiconbtn/msgiconbtn.component';
import { SweetAlertComponent } from './dashboard/sweetalert/sweetalert.component';
import { LoginComponent } from './page/login/login.component';
import { RootComponent } from './dashboard/root/root.component';
import { RegisterComponent } from './page/register/register.component';
import { LockComponent } from './page/lock/lock.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { PriceTableComponent } from './dashboard/component/pricetable/pricetable.component';
import { PanelsComponent } from './dashboard/component/panels/panels.component';

import { SettingsService } from './services/settings.service';
import { WizardComponent } from './dashboard/component/wizard/wizard.component';
// import { AddressComponent } from './pages/address/address.component';
import { DomainsComponent } from './dashboard/domains/domains.component';
import { VehiclesComponent } from './dashboard/administration/vehicles/vehicles.component';
import { DriversComponent } from './dashboard/administration/drivers/drivers.component';
import { LocationsComponent } from './dashboard/locations/locations.component';
import { RoutesComponent } from './dashboard/routes/routes.component';
import { CustomersComponent } from './dashboard/administration/customers/customers.component';
import { TravelsComponent } from './dashboard/travels/travels.component';
import { EditComponent } from './dashboard/administration/vehicles/edit/edit.component';
import { EditDriverComponent } from './dashboard/administration/drivers/edit-driver/edit-driver.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from 'environments/environment';
import { VerificationComponent } from './page/verification/verification.component';
import { EditCustomerComponent } from './dashboard/administration/customers/edit-customer/edit-customer.component';
import { EditDomainComponent } from './dashboard/domains/edit-domain/edit-domain.component';
import { CustomerDomainComponent } from './dashboard/domains/customer-domain/customer-domain.component';
import { RouteDetailComponent } from './dashboard/routes/route-detail/route-detail.component';
import { LocationDetailComponent } from './dashboard/locations/location-detail/location-detail.component';
import { PassengersComponent } from './dashboard/passengers/passengers.component';
import { PasssengerDetailComponent } from './dashboard/passengers/passsenger-detail/passsenger-detail.component';
import { RecurrenciesComponent } from './dashboard/administration/recurrencies/recurrencies.component';
import { EditRecurrencyComponent } from './dashboard/administration/recurrencies/edit-recurrency/edit-recurrency.component';
import { SummaryComponent } from './dashboard/summary/summary.component';
import { SelectDomainComponent } from './components/select-domain/select-domain/select-domain.component';

import { AuthInterceptor } from './helpers/interceptor';
import { AlertsComponent } from './components/alerts/alerts.component';
import { TodayTravelsComponent } from './dashboard/summary/today-travels/today-travels.component';
import { TravelReportComponent } from './components/travel-report/travel-report.component';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';
@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HomeComponent,
    ProfileComponent,
    NavbarComponent,
    FigurecardComponent,
    ImagecardComponent,
    TableComponent,
    NotificationComponent,
    MsgIconBtnComponent,
    SweetAlertComponent,
    LoginComponent,
    RootComponent,
    RegisterComponent,
    LockComponent,
    HeaderComponent,
    FooterComponent,
    SettingsComponent,
    PriceTableComponent,
    PanelsComponent,
    WizardComponent,
    // AddressComponent,
    DomainsComponent,
    VehiclesComponent,
    DriversComponent,
    LocationsComponent,
    RoutesComponent,
    CustomersComponent,
    TravelsComponent,
    EditComponent,
    EditDriverComponent,
    VerificationComponent,
    EditCustomerComponent,
    EditDomainComponent,
    CustomerDomainComponent,
    RouteDetailComponent,
    LocationDetailComponent,
    PassengersComponent,
    PasssengerDetailComponent,
    RecurrenciesComponent,
    EditRecurrencyComponent,
    SummaryComponent,
    SelectDomainComponent,
    AlertsComponent,
    TodayTravelsComponent,
    TravelReportComponent,
    ForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    routing,
    BrowserAnimationsModule,
    MatButtonModule,
    MatRadioModule,
    MatStepperModule,
    MatInputModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatSortModule,
    MatProgressSpinnerModule,
    NgxPrintModule
  ],
  providers: [
    SettingsService, 
    MatDatepickerModule,
    MatNativeDateModule,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  entryComponents: [EditComponent, EditDriverComponent],
  bootstrap: [AppComponent]
  
})
export class AppModule { }
